var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdinicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C13.2261 0 8.64773 1.89642 5.27208 5.27208C1.89642 8.64773 0 13.2261 0 18C0 22.7739 1.89642 27.3523 5.27208 30.7279C8.64773 34.1036 13.2261 36 18 36C22.7739 36 27.3523 34.1036 30.7279 30.7279C34.1036 27.3523 36 22.7739 36 18C36 13.2261 34.1036 8.64773 30.7279 5.27208C27.3523 1.89642 22.7739 0 18 0Z",
    fill: "#0288D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5H12.6V27H9V13.5ZM10.7892 11.7H10.7694C9.6948 11.7 9 10.899 9 9.89908C9 8.87758 9.7164 8.09998 10.8099 8.09998C11.9052 8.09998 12.5793 8.87758 12.6 9.89908C12.6 10.899 11.9052 11.7 10.7892 11.7ZM27.9 18.45C27.9 15.7158 25.6842 13.5 22.95 13.5C21.2742 13.5 19.7955 14.3352 18.9 15.6096V13.5H15.3V27H18.9V19.8C18.9 18.3087 20.1087 17.1 21.6 17.1C23.0913 17.1 24.3 18.3087 24.3 19.8V27H27.9C27.9 27 27.9 18.8289 27.9 18.45Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinicon);
export default __webpack_public_path__ + "static/media/linkdinicon.4cfe0ce560ad52bc223f43d24a1649bc.svg";
export { ForwardRef as ReactComponent };